/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Paper from '@material-ui/core/Paper';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//

import ActionsList from 'components/ActionsList/ActionsList';
import CompanyAssetsTable from 'components/Locations/CompanyAssetsTable';
import CountriesSitesExpandableList from 'components/Locations/CountriesSitesExpandableList/CountriesSitesExpandableList';

import Loading from 'components/Loading/Loading';
import PageWrapper from 'components/PageWrapper/PageWrapper';
import PageTitle from 'components/PageTitleLegacy/PageTitle';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator';
import UsersRoleExpandableList from 'components/User/UsersRoleExpandableList';
import ActionDrawerWrapper from 'components/ActionDrawerWrapper/ActionDrawerWrapper';
import StartAuditByLocations from 'views/ActionDrawer/forms/StartAudit/StartAuditByLocations';

//----------------------------------------------------------------------//
// LOCAL COMPONENTS                                                     //
//----------------------------------------------------------------------//

import type { TypeActionDrawerStore } from 'stores/ActionDrawerStore';

import styles from 'common-scss/DetailsPage.module.scss';

import actionsListData from './actionsListData';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@inject('navigationStore', 'accountStore', 'actionDrawerStore')
@observer
export default class CountryDetailsPage extends React.Component<*> {
  componentDidMount() {
    const accountStore: Object = this.props.accountStore;
    const accountId: string = this.props.match.params.id;
    const companyId: string = this.props.match.params.companyId;
    const countryId: string = this.props.match.params.countryId;

    if (accountStore.accountId !== accountId) {
      accountStore.loadDetails(accountId);
    }

    if (!accountStore.countryDetails || accountStore.countryDetails.id !== countryId) {
      accountStore.loadCountryDetails(companyId, countryId);
    }

    this.props.navigationStore.pushPath(0, '/accounts');
    this.props.navigationStore.pushPath(1, `/accounts/${accountId}`, 0);
    this.props.navigationStore.pushPath(2, `/accounts/${accountId}`, 2);
  }

  componentWillUnmount() {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    actionDrawerStore.clearActionDrawer();
  }

  render(): React.Element<*> {
    const { countryDetails }: Object = this.props.accountStore;

    const accountId: string = this.props.match.params.id;
    const companyId: string = this.props.match.params.companyId;
    const countryId: string = this.props.match.params.countryId;
    const loadingResources: boolean = this.props.accountStore.loadingResources;
    const details: Object = this.props.accountStore.details;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;

    const t: Function = this.props.t;

    if (loadingResources || !details || !countryDetails) {
      return <Loading />;
    }

    const title: string = `
            ${t('general:trading_account_plural')} |
            ${details.details.name} |
            ${t('general:actions.manage_location_plural')} |
            ${countryDetails.name} (${t('general:country')})`;

    return (
      <React.Fragment>
        <PageWrapper isFlex={false}>
          <PageTitle title={title} />

          <div className={styles['grid-wrapper']}>
            <Paper className={styles['feature-item']}>
              <div className={styles['details-panel']}>
                <CountriesSitesExpandableList
                  title={t('general:locations.labels.country_locations')}
                  details={countryDetails}
                  accountId={accountId}
                  companyId={companyId}
                />

                <CompanyAssetsTable
                  title={t('general:locations.assigned_to_country')}
                  countryId={countryDetails.id}
                  companyId={companyId}
                  assetsCount={countryDetails.assets_count}
                />

                <UsersRoleExpandableList
                  title={t('general:users.assigned_to_country')}
                  details={countryDetails}
                  companyId={companyId}
                  countryId={countryId}
                  accountId={accountId}
                />
              </div>

              <div className={styles['actions-panel']}>
                <StatusIndicator title={t('general:locations.labels.status')} status="active" />
                <ActionsList actions={actionsListData} />
              </div>
            </Paper>
          </div>
        </PageWrapper>
        <ActionDrawerWrapper
          onActionCompleted={() => {
            /*overriding with empty fn*/
          }}
        >
          {
            {
              startAudit: <StartAuditByLocations location={countryDetails} type="locations" />,
            }[actionDrawerStore.currentActionDrawer]
          }
        </ActionDrawerWrapper>
      </React.Fragment>
    );
  }
}
